import React from "react";

import "../../../assets/stlyes/SubjectOverView/SubjectOverView.scss";
import "../../../assets/stlyes/SubjectOverView/subjectAreaProgress.scss";

const TableRowElement = (props) => {
  const { value, highest, lowest } = props;
  return (
    <div className="rowElement" style={{ background: highest ? "#99AB47" : lowest ? "#F50057" : "#FAFAFA", border: highest ? "1px solid #99AB47" : lowest ? "1px solid #F50057" : "1px solid #BBB" }}>
      <span className="innerText" style={{ color: highest ? "#FFF" : lowest ? "#FFF" : "#292929" }}>{value === undefined || value === "undefined" ? 0 : Math.round(value)}%</span>
    </div>
  );
}

export { TableRowElement };